import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-star-small-filled",
  "use": "icon-star-small-filled-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-star-small-filled\"><path d=\"M6.386.233l1.419 3.77 3.832.233c.164.016.276.113.335.292.06.179.023.33-.111.455L8.9 7.563l.938 3.839a.389.389 0 0 1-.162.426c-.145.105-.292.118-.441.04l-3.23-2.03-3.262 2.112c-.15.078-.296.065-.442-.04a.389.389 0 0 1-.162-.426l.939-3.84-2.961-2.59a.588.588 0 0 1-.095-.514c.048-.187.17-.288.363-.304l3.822-.233 1.43-3.77A.385.385 0 0 1 6.01 0c.175 0 .3.078.375.233z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol